import React from 'react';
import SimpleHeader from 'ui/simple-header';

const SimpleHeaderTastic = () => {
  return <SimpleHeader />;
};

export default SimpleHeaderTastic;
